import {
  TuiHint,
  tuiItemsHandlersProvider,
  TuiIcon,
  TuiDropdown,
  TuiLabel,
  TuiSelectLike,
  TuiTextfield,
} from '@taiga-ui/core';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  TuiChevron,
  TuiDataListWrapper,
  TuiInputChip,
  TuiMultiSelect,
  TuiTooltip,
} from '@taiga-ui/kit';
import {
  FieldOptionValue,
  WorkflowFormFieldInputMultiselect,
} from '@features/requests/request-form/components/request-form-workflows/types';

@Component({
  selector: 'x-input-multiselect-field',
  imports: [
    ReactiveFormsModule,
    TuiMultiSelect,
    TuiDataListWrapper,
    TuiHint,
    TuiIcon,
    TuiTooltip,
    TuiDropdown,
    TuiChevron,
    TuiInputChip,
    TuiLabel,
    TuiSelectLike,
    TuiTextfield,
  ],
  templateUrl: './input-multiselect-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
  providers: [
    tuiItemsHandlersProvider({
      stringify: signal((item: FieldOptionValue) => item.title),
    }),
  ],
})
export class InputMultiselectFieldComponent {
  field = input.required<WorkflowFormFieldInputMultiselect>();
  control = input.required<FormControl<string[]>>();
}
